const BASE_URL = '/'
const HOME = BASE_URL
const REGISTER = `${BASE_URL}register/:code`
const FORM = `${BASE_URL}formulario`
const FORM_QUESTION = `${BASE_URL}form/:code`
const RESULTS = `${BASE_URL}results/:code`
const THANKS = `${BASE_URL}thanks`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  HOME,
  REGISTER,
  FORM,
  FORM_QUESTION,
  RESULTS,
  THANKS,
  UNAUTHORIZED,
}
